import { SelectedTooltip, Tooltips } from 'store/sidebar/types';

export const TOOLTIP_SLOT_COUNT = 5;

// Slots are positional - the index is the row in the sidebar - so a cleared slot is kept as null
// rather than dropped, otherwise the rows below it would shuffle up.
export const setTooltipSlot = (tooltips: Tooltips, index: number, selection: { id: string, text: string } | null): Tooltips => {
    const slots: Tooltips = new Array(TOOLTIP_SLOT_COUNT).fill(null).map((_, i) => tooltips[i] ?? null);
    const selected: SelectedTooltip | null = selection ? { id: selection.id, name: selection.text } : null;

    slots[index] = selected;

    return slots;
};
